import request from '@/utils/request'
import md5 from "js-md5"
// 登录
export function Login(data) {
    var data = {
        username: data.email,
        password: md5(data.password),
    }
    return request({
        url: '/test1',
        method: 'post',
        data
    })
}
export function getPost(url, data) {
    return request({
        url: url,
        method: 'post',
        data,
    })
}
export function getSearch(url, data) {
    return request({
        url: url,
        method: 'get',
        params: data
    });
}
export function example(data) {
    return request({
        url: '/lnc/func-eg',
        method: 'get',
        params: data,//get请求参数
    })
}